import React, {Component} from 'react'
import PropTypes from 'prop-types'


class FilterByHumanTime extends Component {
    _handleChange = async (e) => {
        const {value} = e.target

        if (this.props.loading) return false

        const {filter, onSubmit, onChange} = this.props
        const updatedFilter = {...filter, time: value}

        await onChange(updatedFilter)
        onSubmit()
    }

    render() {
        const {filter, loading} = this.props
        const {time} = filter

        return (
            <div className="FilterByHumanTime mb-3">
                <select disabled={loading} value={time}
                        onChange={this._handleChange}
                        className="form-control"
                        name="filter-by-day">
                    <option value="today">Hôm nay</option>
                    <option value="yesterday">Hôm qua</option>
                    <option value="last-3-days">3 ngày vừa qua</option>
                    <option value="last-7-days">7 ngày vừa qua</option>
                    <option value="last-14-days">2 tuần vừa qua</option>
                </select>
            </div>
        )
    }
}

FilterByHumanTime.propTypes = {
    filter: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default FilterByHumanTime
